//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,toCopy} from '@/utils/util.js'
import homeTip from '@/components/homeTip'


export default {
  name: "qualityOrderDetailAll",
  components: {
    homeTip
  },
  data() {
    return {
      toCopy,
      reasonList:[
        {reason:'面料疵点',number:5,type:'一般'},
        {reason:'面料疵点',number:5,type:'一般'},
        {reason:'面料疵点',number:5,type:'一般'},
        {reason:'面料疵点',number:5,type:'一般'},
      ],
      basicForm: {
        qualityOrderSn: '',
        sendOrderSn: '',
        purchaseOrderSn: '',
        supplierName: '',
        channelStr: '',
        qualityOrderTypeName: '',
        qualityOrderDetailList: [],
        qualityOrderResultDetailList: [],
        attachedFile: [],
        isStockIn:'',
        confirmFileStr:'',
        confirmFile:'',
        remark:'',
        qualityResult:'',
        qualityOrderStatusName:'',
        billDate:'',
        externalOrder:'',
        needAduit:'',
        spuCode:'',
        sendTotalGoodsNum:'',
        crtTime:'',
        percent:'',
      },
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.qualityOrderId) {
      this.qualityOrderId = this.$route.query.qualityOrderId
    }
    this.getSpecList()
  },
  methods: {
    getSpecList() {
      var queryParams = {
        qualityOrderId:this.qualityOrderId
      };
      axiosApi.queryQualityOrder(queryParams).then(response => {
        var data = response.content;
        if(data.qualityOrderDetailList){
          data.qualityOrderDetailList.forEach((item)=>{item.isEdit = true})
        }
        for (var ind in data) {
          var val = data[ind] != null ? data[ind] : ""
          this.$set(this.basicForm, ind, val)
        }
        var channelStr = '';
        if(this.basicForm.firstDeptName){
          channelStr+=this.basicForm.firstDeptName
        }
        if(this.basicForm.secondDeptName){
          channelStr+='/'+this.basicForm.secondDeptName
        }
        this.$set(this.basicForm, 'channelStr', channelStr)
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    },
    toMore(){
      this.$router.push({name:'qualityOrderDetailMore'})
    },
    toBase(){
      this.$router.push({name:'qualityOrderDetailBase'})
    },
    toAddReason(){
      this.$router.push({name:'addReason',type:2})
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityAllOrder/detailAll.vue